var audio_rtlignore_default = {
  "fontElementMap": "gQ189",
  "customPlayer": "DTvx1",
  "customPlayer_basic": "I4LdF",
  "customPlayer_mobile": "NA1T2",
  "audio_coverImg": "Kv1n5",
  "audio_small_cover_image": "_1af3-",
  "audio_icon_button": "eE6Se",
  "audio_contextMenu_wrapper": "ZZL2o",
  "customPlayer_with_image": "H8mnv",
  "track_wrapper": "l82tx",
  "trackContainer": "htrW6",
  "audio_download_icon": "_4UMVC",
  "audio_duration": "_0usAT",
  "customPlayer_small_fit": "WvbeV",
  "track_sliders_wrapper": "Aad5O",
  "audio_volume_wrapper": "raeHW",
  "volume_slider_wrapper": "z-TR1",
  "audioDetails": "wAisS",
  "title": "dhLsx",
  "author_name": "_7vuIN",
  "dropdown_menu_wrapper": "_2xRaL",
  "dropdown_selected_button": "L6V-J",
  "dropdown_content": "_93Z50",
  "dropdown_content_withIcon": "VhOaf",
  "audio_loader_icon": "m0t-N",
  "spin": "kvuq5"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
